export default function Header() {
  return (
    <header className="relative bg-gradient-to-br from-amber-50 via-orange-50 to-rose-50 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-0 left-0 w-96 h-96 bg-amber-200 rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-rose-200 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-orange-200 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-4000"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 py-24 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight">
          ICK to STICK Guide
        </h1>
        <p className="text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto mb-8 leading-relaxed">
          Learn to build partnerships that actually stick (and are a lot more fun)
        </p>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Thoughtful tools to help you attract and nurture aligned partnerships
        </p>
        
        {/* ICK to STICK Image */}
        <div className="mt-12 flex justify-center">
          <img 
            src="https://static.readdy.ai/image/28da5b82b62ca95ef0a33638ffb4027e/7e5c904e9bc5e9b05f2cd5e01069e14a.png" 
            alt="ICK to STICK Framework" 
            className="max-w-2xl w-full h-auto rounded-lg shadow-lg"
          />
        </div>
      </div>
    </header>
  );
}
